import React, { useState, useRef, useEffect } from "react";
import Pack from "./Pack";

const FAQBox = ({ faq }) => {
  const [openIndices, setOpenIndices] = useState([]);
  const [heights, setHeights] = useState({});
  const answerRefs = useRef([]);

  const itemsArray = React.useMemo(() => {
    if (Array.isArray(faq.items)) {
      return faq.items;
    }
    return Object.entries(faq.items).map(([key, value]) => ({ key, ...value }));
  }, [faq.items]);

  const handleToggle = (index) => {
    setOpenIndices((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  useEffect(() => {
    const newHeights = {};
    answerRefs.current.forEach((ref, idx) => {
      if (ref) newHeights[idx] = ref.scrollHeight;
    });
    setHeights(newHeights);
  }, [openIndices]);

  return (
    <Pack idSection={faq.id} dataComponent={"faq-box"}>
      <h2 className="title">{faq.title}</h2>
      <div className="box faq">
        {itemsArray.map((item, idx) => (
          <div
            key={item.key || idx}
            className={`faq__item ${
              openIndices.includes(idx) ? "is-open" : ""
            }`}
          >
            <h3 className="faq__question" onClick={() => handleToggle(idx)}>
              {item.question}
            </h3>
            <div
              className="faq__answer"
              ref={(el) => (answerRefs.current[idx] = el)}
              style={{
                maxHeight: openIndices.includes(idx)
                  ? `${heights[idx]}px`
                  : "0",
                marginTop: "10px",
                cursor: "default",
              }}
            >
              {item.answer}
            </div>
          </div>
        ))}
      </div>
    </Pack>
  );
};

export default FAQBox;
